// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LibroReclamaciones_container__\\+YWXG {
  min-height: 80vh;
  background-color: #f0f4f8;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 60px 20px;
  box-sizing: border-box;
}

.LibroReclamaciones_card__Wxvzb {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 48px 52px;
  width: 100%;
  max-width: 720px;
  box-sizing: border-box;
}

.LibroReclamaciones_header__Y3qqR {
  text-align: center;
  margin-bottom: 36px;
}

.LibroReclamaciones_bookIcon__62Xu1 {
  font-size: 40px;
}

.LibroReclamaciones_title__tt6aV {
  font-size: 1.8rem;
  font-weight: 700;
  color: #1a3a5c;
  margin: 12px 0 10px;
}

.LibroReclamaciones_subtitle__i1Lgz {
  font-size: 14px;
  color: #667085;
  line-height: 1.6;
  max-width: 520px;
  margin: 0 auto;
}

/* Formulario */
.LibroReclamaciones_form__Jdc4j {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.LibroReclamaciones_formGrid__NWwnC {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 28px;
}

.LibroReclamaciones_field__l1Qkc {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.LibroReclamaciones_label__IX7pn {
  font-size: 12px;
  font-weight: 600;
  color: #344054;
  letter-spacing: 0.3px;
}

.LibroReclamaciones_input__bYRj-,
.LibroReclamaciones_select__LTu8Q,
.LibroReclamaciones_textarea__MJfg\\+ {
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
  color: #344054;
  background: #ffffff;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s;
  font-family: inherit;
}

.LibroReclamaciones_input__bYRj-:focus,
.LibroReclamaciones_select__LTu8Q:focus,
.LibroReclamaciones_textarea__MJfg\\+:focus {
  border-color: #1a3a5c;
}

.LibroReclamaciones_textarea__MJfg\\+ {
  resize: vertical;
}

.LibroReclamaciones_btn__fiZWT {
  width: 100%;
  padding: 14px;
  background-color: #1a3a5c;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.LibroReclamaciones_btn__fiZWT:hover {
  background-color: #142e4a;
}

/* Éxito */
.LibroReclamaciones_successBox__MvJAt {
  text-align: center;
  padding: 40px 20px;
}

.LibroReclamaciones_successIcon__VpCBi {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  background-color: #2db899;
  border-radius: 50%;
  color: white;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 16px;
}

.LibroReclamaciones_successBox__MvJAt h2 {
  font-size: 1.4rem;
  color: #1a3a5c;
  margin-bottom: 8px;
}

.LibroReclamaciones_successBox__MvJAt p {
  color: #667085;
  font-size: 14px;
}

@media (max-width: 600px) {
  .LibroReclamaciones_card__Wxvzb {
    padding: 32px 20px;
  }

  .LibroReclamaciones_formGrid__NWwnC {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LibroReclamaciones/LibroReclamaciones.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".container {\n  min-height: 80vh;\n  background-color: #f0f4f8;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 60px 20px;\n  box-sizing: border-box;\n}\n\n.card {\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\n  padding: 48px 52px;\n  width: 100%;\n  max-width: 720px;\n  box-sizing: border-box;\n}\n\n.header {\n  text-align: center;\n  margin-bottom: 36px;\n}\n\n.bookIcon {\n  font-size: 40px;\n}\n\n.title {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin: 12px 0 10px;\n}\n\n.subtitle {\n  font-size: 14px;\n  color: #667085;\n  line-height: 1.6;\n  max-width: 520px;\n  margin: 0 auto;\n}\n\n/* Formulario */\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.formGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 28px;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #344054;\n  letter-spacing: 0.3px;\n}\n\n.input,\n.select,\n.textarea {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #344054;\n  background: #ffffff;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.2s;\n  font-family: inherit;\n}\n\n.input:focus,\n.select:focus,\n.textarea:focus {\n  border-color: #1a3a5c;\n}\n\n.textarea {\n  resize: vertical;\n}\n\n.btn {\n  width: 100%;\n  padding: 14px;\n  background-color: #1a3a5c;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.btn:hover {\n  background-color: #142e4a;\n}\n\n/* Éxito */\n.successBox {\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.successIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  background-color: #2db899;\n  border-radius: 50%;\n  color: white;\n  font-size: 24px;\n  font-weight: 700;\n  margin-bottom: 16px;\n}\n\n.successBox h2 {\n  font-size: 1.4rem;\n  color: #1a3a5c;\n  margin-bottom: 8px;\n}\n\n.successBox p {\n  color: #667085;\n  font-size: 14px;\n}\n\n@media (max-width: 600px) {\n  .card {\n    padding: 32px 20px;\n  }\n\n  .formGrid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LibroReclamaciones_container__+YWXG`,
	"card": `LibroReclamaciones_card__Wxvzb`,
	"header": `LibroReclamaciones_header__Y3qqR`,
	"bookIcon": `LibroReclamaciones_bookIcon__62Xu1`,
	"title": `LibroReclamaciones_title__tt6aV`,
	"subtitle": `LibroReclamaciones_subtitle__i1Lgz`,
	"form": `LibroReclamaciones_form__Jdc4j`,
	"formGrid": `LibroReclamaciones_formGrid__NWwnC`,
	"field": `LibroReclamaciones_field__l1Qkc`,
	"label": `LibroReclamaciones_label__IX7pn`,
	"input": `LibroReclamaciones_input__bYRj-`,
	"select": `LibroReclamaciones_select__LTu8Q`,
	"textarea": `LibroReclamaciones_textarea__MJfg+`,
	"btn": `LibroReclamaciones_btn__fiZWT`,
	"successBox": `LibroReclamaciones_successBox__MvJAt`,
	"successIcon": `LibroReclamaciones_successIcon__VpCBi`
};
export default ___CSS_LOADER_EXPORT___;
